module.exports = __webpack_public_path__ + "res/quiz.4a2e6aa244577c376369d46e4407481a.webp";